var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoSblive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "sblive-sports-wordmark",
    xmlns: "http://www.w3.org/2000/svg",
    width: 1271.857,
    height: 249.85,
    viewBox: "0 0 1271.857 249.85",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Final_-_Option_1",
    "data-name": "Final - Option 1",
    d: "M114.55,131.36H30.48L45.54,78.82h.09L57.31,38.06A52.55,52.55,0,0,1,107.82,0H340.93L265.79,78.82H129.61ZM211.32,171H75.14L0,249.85H233.11a52.549,52.549,0,0,0,50.509-38.057L295.31,171h.08l15.07-52.54H226.38Z",
    fill: "#00bbf2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_16854",
    "data-name": "Path 16854",
    d: "M533.93,107.88l-4.55,15.68-4.45,15.53a31.68,31.68,0,0,1-30.47,23H344.37l36.71-38.49h97.65l5-17.6H400.39a31.69,31.69,0,0,1-30.46-40.42L375,49.87l3.9-15.55a31.69,31.69,0,0,1,30.47-23H559.49L523,50.08l-97.88-.14-5,17.53h83.37a31.69,31.69,0,0,1,30.44,40.41Z",
    fill: "#2a2d43"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_16855",
    "data-name": "Path 16855",
    d: "M719.59,84.68a20.6,20.6,0,0,0,7-10.43L733,51.79A31.67,31.67,0,0,0,703.4,11.4H575.75l-43.2,150.68H687a31.69,31.69,0,0,0,30.46-23l9.3-32.45a20.56,20.56,0,0,0-7.17-21.95ZM682.86,49.87l-5,17.59H610.37l5-17.59Zm-88.57,73.68,5-17.59h77l-5,17.59Z",
    fill: "#2a2d43"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_16856",
    "data-name": "Path 16856",
    d: "M866.3,123.55h-77L821.51,11.37h-50.7L727.6,162.05H882.08a31.67,31.67,0,0,0,30.46-23l4.46-15.5Z",
    fill: "#2a2d43"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_16857",
    "data-name": "Path 16857",
    d: "M924.43,162.05h41.2L998.41,47.7H957.22Z",
    fill: "#2a2d43"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_16858",
    "data-name": "Path 16858",
    d: "M1110.96,47.7l-56.01,82.48-8.71-82.48h-38.22l14.02,114.35h47.54l79.6-114.35Z",
    fill: "#2a2d43"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_16859",
    "data-name": "Path 16859",
    d: "M1249.66,47.7h-76.94a22.19,22.19,0,0,0-21.32,16.07l-19.73,70A22.19,22.19,0,0,0,1151.8,162h78.26a22.15,22.15,0,0,0,20.87-16l3.58-12.45h0l.91-3.17H1169l3.63-12.81h74.51a15.84,15.84,0,0,0,15.23-11.47L1271,76a22.19,22.19,0,0,0-21.34-28.3Zm-69.84,44.5,3.63-12.81h50.12L1229.9,92.2Z",
    fill: "#2a2d43"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_16860",
    "data-name": "Path 16860",
    d: "M944.8,229.24c-.74,11.06-10,17.08-24.35,17.08-15.77,0-25.26-7.92-25.26-20.39h14.69c0,6.28,5.62,8.26,11.39,8.26,5.12,0,8.34-1.57,8.75-5.45.5-5-5-5.45-12.46-8.17-10-3.63-17.67-8.26-16.1-19.57,1.65-11.64,12-16.34,24.35-16.34,14.2,0,22.87,7.59,22.87,18.9H934.07c.16-4.45-3.63-6.77-8.92-6.77-4.87,0-8.58,1.41-9,4.63s2.55,4.7,9.08,7.18C937,213.14,945.71,216.19,944.8,229.24Z",
    fill: "#00bbf2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_16861",
    "data-name": "Path 16861",
    d: "M958.34,186h28.23c12.3,0,19.07,6.77,16.6,19.56-2.31,12-10.73,18.08-23,18.08H965.94L961.73,245H946.87Zm9.91,25.51h10.23c5.12,0,9.08-2.07,10.16-7.43.82-4.54-1.57-5.95-6.69-5.95H970.89Z",
    fill: "#00bbf2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_16862",
    "data-name": "Path 16862",
    d: "M1005.07,214.71c3.3-17.34,15.85-30.05,34.17-30.05,19,0,27.49,13.37,23.94,31.53-3.38,17.42-16.09,30.13-34.25,30.13C1009.77,246.32,1001.52,233,1005.07,214.71Zm43.59,0c1.89-9.83.24-17.92-10.08-17.92-11.22,0-16.92,8.75-19,19.4-1.9,9.91-.33,18,10.07,18C1040.81,234.19,1046.51,225.44,1048.66,214.71Z",
    fill: "#00bbf2"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_16863",
    "data-name": "Path 16863",
    d: "M1074.08,186h27.41c13.13,0,20.23,6.36,18,17.91-1.49,7.43-6.61,12.14-14.12,13.79l-1,.16c14.28,2.56,4.46,25.43,7.68,26.42l.24.74-15-.24c-2.48-2.48,6.52-20.31-6.11-20.31h-9.66l-4,20.55h-14.86Zm9.75,26.33h9.65c6,0,10-2.47,11.06-7.84.83-4.54-1.48-6.36-7.42-6.36h-10.49Z",
    fill: "#00bbf2"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_16864",
    "data-name": "Path 16864",
    d: "M1137.24,198.11h-17.17l2.31-12.13h49.12l-2.31,12.13H1152.1L1142.93,245h-14.85Z",
    fill: "#00bbf2"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_16865",
    "data-name": "Path 16865",
    d: "M1215.83,229.24c-.74,11.06-10,17.08-24.35,17.08-15.77,0-25.26-7.92-25.26-20.39h14.69c0,6.28,5.61,8.26,11.39,8.26,5.12,0,8.34-1.57,8.75-5.45.5-5-5-5.45-12.46-8.17-10-3.63-17.67-8.26-16.1-19.57,1.65-11.64,12-16.34,24.35-16.34,14.2,0,22.87,7.59,22.87,18.9H1205.1c.16-4.45-3.64-6.77-8.92-6.77-4.87,0-8.58,1.41-9,4.63s2.56,4.7,9.08,7.18C1208.07,213.14,1216.74,216.19,1215.83,229.24Z",
    fill: "#00bbf2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSblive);
export default __webpack_public_path__ + "static/media/logo-sblive.e9bc9c6a2c738332691d9b5d756fc1ed.svg";
export { ForwardRef as ReactComponent };